'use client'

import React from 'react'
import { SWRConfig } from 'swr'

import { DataStoreProvider } from '@/contexts/DataStoreContext'
import { swrConfig } from '@/utils/api/swr-config'

import { TamaguiProvider } from './TamaguiProvider'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <TamaguiProvider>
      <SWRConfig value={swrConfig}>
        <DataStoreProvider>{children}</DataStoreProvider>
      </SWRConfig>
    </TamaguiProvider>
  )
}
